import type { DemandSuppressionMasterRow } from '~/pages/AdminOcctoMaster/tabs/DemandSuppressionPlanMaster/types'
import type { CsvColumnDef } from '~/pages/AdminOcctoMaster/tabs/_common/models/csvExport'

/**
 * 需要抑制計画マスタタブの CSV エクスポート カラム定義
 * (spec AC-012b / design doc §5「タブ別 CSV カラム」)。
 * List レスポンスのフィールドのみを対象とし (AC-04)、詳細モーダルでのみ
 * 見える需要抑制契約 / 取引先 BG の各リスト明細は含まない (件数のみを出力する)。
 */
export function demandSuppressionPlanMasterCsvColumns(): Array<
  CsvColumnDef<DemandSuppressionMasterRow>
> {
  return [
    {
      headerKey:
        'page:adminOcctoMaster.demandSuppressionPlanMaster.column.submitterCode',
      accessor: (row) => row.submitterCode,
    },
    {
      headerKey:
        'page:adminOcctoMaster.demandSuppressionPlanMaster.column.note',
      accessor: (row) => row.note ?? '',
    },
    {
      headerKey:
        'page:adminOcctoMaster.demandSuppressionPlanMaster.column.contractCount',
      accessor: (row) => String(row.contractCount),
    },
    {
      headerKey:
        'page:adminOcctoMaster.demandSuppressionPlanMaster.column.partnerBgCount',
      accessor: (row) => String(row.partnerBgCount),
    },
  ]
}
